
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { href: '#reserve', label: 'WEB予約' },
    { href: '#system', label: '料金システム' },
    { href: '#access', label: 'アクセス' },
    { href: '#notes', label: '注意事項' },
  ];

  const handleAnchorClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-pink-50 via-rose-50 to-pink-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo & Description */}
        <div className="text-center mb-12">
          <button onClick={() => handleAnchorClick('#reserve')} className="inline-block mb-4 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/7a6803503a084ffa064c71a8e4677aa3/cf44141841b9b36e73ca82220febca80.png"
              alt="JDスパ ロゴ"
              className="h-20 w-auto object-contain mx-auto"
            />
          </button>
          <p className="text-gray-600 text-sm max-w-md mx-auto">
            上質な癒し時間を、もっと身近に女子大生と♡
          </p>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-wrap justify-center gap-6 mb-8">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleAnchorClick(link.href)}
              className="text-gray-600 hover:text-pink-500 transition-colors duration-200 text-sm cursor-pointer"
            >
              {link.label}
            </button>
          ))}
        </nav>

        {/* Phone */}
        <div className="flex justify-center mb-10">
          <a
            href="tel:07089644442"
            className="flex items-center gap-3 px-8 py-4 bg-white border-2 border-pink-200 rounded-2xl shadow-sm hover:shadow-md hover:border-pink-400 transition-all duration-200 cursor-pointer"
          >
            <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full">
              <i className="ri-phone-line text-pink-500 text-xl"></i>
            </div>
            <div>
              <p className="text-xs text-gray-400 mb-0.5">電話受付</p>
              <p className="text-xl font-bold text-pink-500 tracking-wider">070-8964-4442</p>
            </div>
          </a>
        </div>

        {/* Divider */}
        <div className="border-t border-pink-200 mb-8"></div>

        {/* Copyright */}
        <div className="text-center text-gray-500 text-sm">
          <p>Copyright © {currentYear} JDスパ. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
